;(function () {
  angular.module('contrast.filters').filter('timeNumber', function () {
    return function (bytes) {
      if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
        return '-'
      }
      if (bytes == 0) {
        return 0
      }

      var timeDays = 60 * 60 * 24
      var timeHour = 60 * 60
      var timeMinute = 60

      var number = Math.floor(bytes / timeDays)
      if (number == 0) {
        number = Math.floor(bytes / timeHour)
        if (number == 0) {
          number = Math.floor(bytes / timeMinute)
          if (number == 0) {
            return '< 1'
          }
        }
      }
      return number
    }
  })
})()
